<template>
    <c-card-iterator
        label           = "Index"
        :items          = "assessments"
        :pagination-on  = "true"
        :item-height    = "155"
        :height         = "795"
    >
        <template v-slot:card="{ item }">
            <c-assessment-card
                :item        = "item"
                :background  = "background(selected, item)"
                @selected    = "onSelected"
            />
        </template>
    </c-card-iterator>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import CCardIterator    from "@/modules/core/components/utils/CCardIterator";
import CAssessmentCard from "@/modules/inc/assessments/components/CAssessmentCard";

export default {
    name: "CAssessmentCardIterator",

    components: {
        CAssessmentCard,
        CCardIterator
    },

    props: {
        assessments: {

        }
    },

    data: () => ({
        selected: null,
    }),


    methods: {
        onSelected (maintenance) {
            if (this.selected && this.selected.id === maintenance.id) {
                this.selected = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = maintenance;
            Core.fire.selected(this, this.selected);
        },

        background (selected, maintenance) {
            if (selected && selected.id === maintenance.id) {
                return "background-selected"
            }

            return null;
        },
    }
}
</script>

<style scoped>

</style>